/**
 * Bornes de période du tableau de bord, au format AAAA-MM-JJ et dans le
 * fuseau du poste (comme la clôture et le cockpit financier, qui posent les
 * mêmes bornes : un chiffre du tableau de bord doit se retrouver à l'identique
 * sur ces écrans).
 */

export function toIsoDay(d: Date): string {
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}

/** [lundi, dimanche] de la semaine courante décalée de `offset` semaines (même calcul que la clôture). */
export function semaine(offset = 0, now: Date = new Date()): { from: string; to: string } {
  const daysSinceMonday = (now.getDay() + 6) % 7; // getDay() : 0 = dimanche
  const monday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - daysSinceMonday + offset * 7);
  const sunday = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6);
  return { from: toIsoDay(monday), to: toIsoDay(sunday) };
}

/** [1er du mois, aujourd'hui] : le cumul mensuel du cockpit financier. */
export function moisEnCours(now: Date = new Date()): { from: string; to: string } {
  return {
    from: toIsoDay(new Date(now.getFullYear(), now.getMonth(), 1)),
    to: toIsoDay(now),
  };
}

/** [aujourd'hui, aujourd'hui + n - 1] : les n prochains jours, aujourd'hui compris. */
export function prochainsJours(n: number, now: Date = new Date()): { from: string; to: string } {
  return {
    from: toIsoDay(now),
    to: toIsoDay(new Date(now.getFullYear(), now.getMonth(), now.getDate() + n - 1)),
  };
}
